import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AccountAccessService } from '../services/account-access.service';
import { GrToastService } from '../services/toast.service';

/**
 * `AccountSettingsAccess` has existed since roles shipped and nothing consulted it, so anyone who
 * reached the route got full edit affordances. The guard is the single place that answer is
 * enforced; sections read `AccountAccessService.canEditSettings` to decide read-only vs editable.
 */
export const accountSettingsGuard: CanActivateFn = (route) => {
  const access = inject(AccountAccessService);
  const router = inject(Router);
  const toasts = inject(GrToastService);

  const accountId = route.paramMap.get('accountId');
  if (!accountId) return router.parseUrl('/accounts');

  if (access.settingsAccess(accountId) === 'none') {
    toasts.warning(
      'You do not have a role on that account, so its settings are not available to you.',
      'No access',
    );
    return router.parseUrl('/accounts');
  }

  if (route.data['requiresEdit'] && !access.canEditSettings(accountId)) {
    toasts.warning('Your role can view these settings but cannot edit them.', 'Read only');
    return router.createUrlTree(['/account', accountId, 'profile']);
  }

  return true;
};
